module.exports = __webpack_public_path__ + "static/media/Hair_1_green.f01f633a.svg";